//customerSupportPage.jsx

import styled from "styled-components";
import PieChart from "../../components/charts/PieChart";
import Users from "../users/Users";
import DemoData from "../../data/DemoData";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useParams } from "react-router-dom";
import axios from "axios";
import ENDPOINT from "../../context/EndPoint";
import SecurityHeaders from "../../context/SecurityHeaders";
import GetStatistics from "../../actions/statistics/GetStatistics";
import { connect, useDispatch } from "react-redux";
import AdminDeleteTickets from "../../actions/student/AdminDeleteTickets";
import AdminUpdateDoubtRequest from "../../actions/support/AdminUpdateDoubtRequest";
import {
  StudentDoubtSupportProvider,
  useContactRequests,
} from "../../context/support/StudentDoubtSupportContext";
import CustomerSupportTicketItem from "./CustomerTicketItem";
import { useActionsContext } from "../../context/ActionsContext";
import FetchCustomerTickets from "../../actions/support/FetchCustomerTickets";
import CustomerTicketsList from "./CustomerTicketsList";
import Localbase from "localbase";
import DashboardBargraph from "../../components/charts/DashboardBargraph";

function CustomerSupportPage({ value, dispatch, options }) {
  const { user } = useContext(AuthContext);
  const userdata = user;

  const { enablestats } = useActionsContext();
  const [doubts, setdoubts] = useState(null);
  const params = useParams();
  const [status, setstatus] = useState("all");
  const db = new Localbase("db");
  const [query, setquery] = useState(null);

  const [resolutions, setresolutions] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [toast, settoast] = useState(false);
  const [toasttitle, settoasttitle] = useState(null);
  const [info, setinfo] = useState(null);
  const [toastmessage, settoastmessage] = useState(null);

  const GetStats = async () => {
    try {
      dispatch({ type: "LOADING" });

      const res = await GetStatistics({
        payload: { SessionId: user.SessionId },
      });

      if (res) {
        if (res.status === "success") {
          dispatch({ type: "DONE_LOADING" });
          setinfo(res.data);
          // db.collection('paths').add({info})
        } else {
          dispatch({ type: "ERROR", payload: res.error.message });
        }
        // console.log("stat is" + JSON.stringify(res));
      }
    } catch (error) {
      dispatch({ type: "ERROR", payload: error.message });
    }
  };

  const [requestDelete, setRequestDelete] = useState("");

  useEffect(() => {
    db.collection("paths")
      .doc("info")
      .get()
      .then((data) => {
        if (data) {
          setinfo(data.info);
        }
        GetStats();
      });
  }, []);

  // Initialize the response state with the provided data

  const [response, setResponse] = useState(doubts);
  const [searchTerm, setSearchTerm] = useState("");

  // Function to handle changes in the search input
  const { searchquery } = useActionsContext();
  useEffect(() => {
    handleSearch({ term: searchquery });
  }, [searchquery]);
  const handleSearch = ({ term }) => {
    if (!term) {
      setResponse(doubts);
      setSearchTerm("");
      return;
    }

    if (term && doubts) {
      const filteredData = doubts.filter((item) => {
        return (
          (item.email &&
            item.email.toLowerCase().includes(term.toLowerCase())) ||
          (item.phone && item.phone.includes(term)) ||
          (item.name && item.name.toLowerCase().includes(term.toLowerCase())) ||
          (item.message &&
            item.message.toLowerCase().includes(term.toLowerCase())) ||
          (item.status &&
            item.status.toLowerCase().includes(term.toLowerCase())) ||
          (item.create_datetime &&
            item.create_datetime.toLowerCase().includes(term.toLowerCase()))
        );
      });

      setResponse(filteredData);
      setSearchTerm(term);
    }
  };

  const Reload = () => {
    FetchCustomerRequests();
  };

  const [statistics, setstatistics] = useState(null);
  // const Statistics = async () => {
  //   try {
  //     dispatch({ type: "LOADING" });
  //     const data = new FormData();
  //     data.append("session", user.SessionId);

  //     const res = await axios.post(
  //       ENDPOINT + "customer-support-statistics.php",
  //       data,
  //       SecurityHeaders
  //     );

  //     if (res) {
  //       if (res.data.status === "success") {
  //         dispatch({ type: "DONE_LOADING" });
  //         setstatistics(res.data.data);
  //         ///
  //         db.collection("paths").add(
  //           { statistics: res.data.data },
  //           "statistics"
  //         );
  //         ///
  //       } else {
  //         dispatch({ type: "ERROR", payload: res.error.message });
  //       }
  //     }
  //   } catch (error) {
  //     dispatch({ type: "ERROR", payload: error.message });
  //   }
  // };
  const [limit, setlimit] = useState(100);

  const { rowsPerPage, setRowsPerPage } = useActionsContext();

  const FetchCustomerRequests = async () => {
    try {
      dispatch({ type: "LOADING" });
      const res = await FetchCustomerTickets({
        payload: { SessionId: user.SessionId, limit: rowsPerPage },
      });

      if (res) {
        dispatch({ type: "DONE_LOADING" });
        db.collection("paths").add(
          { customer_tickets: res.data },
          "customer_tickets"
        );
        setdoubts(res.data);
        console.log(res);
      } else {
        dispatch({ type: "ERROR", payload: res.error.message });
      }
    } catch (error) {
      dispatch({ type: "ERROR", payload: error.message });
    }
  };
  ///
  // useEffect(() => {
  //   db.collection("paths")
  //     .doc("statistics")
  //     .get()
  //     .then((data) => {
  //       if (data) {
  //         setstatistics(data.statistics);
  //       }
  //     });
  //   Statistics();
  // }, []);

  ///
  useEffect(() => {
    db.collection("paths")
      .doc("customer_tickets")
      .get()
      .then((data) => {
        if (data) {
          setdoubts(data.customer_tickets);
        }
      });
    FetchCustomerRequests();
  }, [rowsPerPage]);

  useEffect(() => {
    setResponse(doubts);
  }, [doubts]);

  const [stats, setstats] = useState(value.statisticsHandler.statistics);
  useEffect(() => {
    setstats(value.statisticsHandler.statistics);
  }, [value.statisticsHandler.statistics]);

  const { voiceinput } = useActionsContext();
  useEffect(() => {
    console.log(voiceinput);
    if (response) {
      if (voiceinput.includes("searchfor") || voiceinput.includes("search")) {
        var name = voiceinput;
        if (voiceinput.includes("searchfor")) {
          name = voiceinput.replace("searchfor", "");
        } else if (voiceinput.includes("search")) {
          name = voiceinput.replace("search", "");
        }

        handleSearch({ term: name });
      }
    }
  }, [voiceinput]);
  useEffect(() => {
    if (searchTerm) {
      handleSearch({ term: searchTerm });
    }
  }, [searchTerm, voiceinput]);

const [view, setView] = useState("total");
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth());
  const [weekIndex, setWeekIndex] = useState(0);

  const [monthsData, setMonthsData] = useState([]);
  const [weekData, setWeekData] = useState([]); // 🔑 SELECTED WEEK DATA
  // const [fetchStats, setFetchStats] = useState(null);

  const fetchStats = async () => {
    if (!user?.SessionId) return;

    try {
      const fd = new FormData();
fd.append("session", user.SessionId);
fd.append("year", year);
fd.append("month", month);
fd.append("week", weekIndex);
fd.append("view", view);

      const res = await axios.post(
        ENDPOINT + "customer-support-statistics.php",
        fd,
        SecurityHeaders
      );

      if (res.data?.status === "success") {
        setMonthsData(res.data.data.months || []);
        setWeekData(res.data.data.selectedWeek || []);
        // FetchCustomerRequests()
        // setstatistics(res.data.data); 
      }
    } catch (err) {
      console.error(err);
    }
  };

  // useEffect(() => {
  //   fetchStats();
  // }, [user?.SessionId, year, month, weekIndex, view]);
  useEffect(() => {
  fetchStats();
}, [user?.SessionId, year, month, weekIndex, view]);

  return (
    <>
      <div className="container-fluid p-0">
        <div className="w-100">
          <div className="w-100">
            <div className="h-100">
              {/*  <> 
              {statistics && (
                <div className="row g-3 mb-3">
                  <div className="col-lg-3 col-md-6 col-12">
                    <div className="card h-100">
                      <div className="card-body d-flex align-items-center">
                        <div className="avatar-sm">
                          <span className="avatar-title bg-light text-primary rounded-circle fs-3">
                            <i className="ri-arrow-down-circle-fill" />
                          </span>
                        </div>
                        <div className="ms-3 flex-grow-1">
                          <p className="text-uppercase text-muted mb-1">
                            Initiated
                          </p>
                          <h4>{statistics.total_initiated}</h4>
                        </div>
                        <span className="badge bg-danger-subtle text-danger">
                          {Math.round(statistics.percentage_initiated)}%
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12">
                    <div className="card h-100">
                      <div className="card-body d-flex align-items-center">
                        <div className="avatar-sm">
                          <span className="avatar-title bg-light text-primary rounded-circle fs-3">
                            <i className="ri-check-double-fill" />
                          </span>
                        </div>
                        <div className="ms-3 flex-grow-1">
                          <p className="text-uppercase text-muted mb-1">
                            Closed
                          </p>
                          <h4>{statistics.total_closed}</h4>
                        </div>
                        <span className="badge bg-success-subtle text-success">
                          {statistics.percentage_closed}%
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12">
                    <div className="card h-100">
                      <div className="card-body d-flex align-items-center">
                        <div className="avatar-sm">
                          <span className="avatar-title bg-light text-warning rounded-circle fs-3">
                            <i className="ri-error-warning-fill" />
                          </span>
                        </div>
                        <div className="ms-3 flex-grow-1">
                          <p className="text-uppercase text-muted mb-1">
                            Unresolved
                          </p>
                          <h4>{statistics.total_unresolved}</h4>
                        </div>
                        <span className="badge bg-warning-subtle text-warning">
                          {statistics.percentage_unresolved}%
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12">
                    <div className="card h-100">
                      <div className="card-body d-flex align-items-center">
                        <div className="avatar-sm">
                          <span className="avatar-title bg-light text-primary rounded-circle fs-3">
                            <i className="ri-file-list-3-fill" />
                          </span>
                        </div>
                        <div className="ms-3 flex-grow-1">
                          <p className="text-uppercase text-muted mb-1">
                            Total
                          </p>
                          <h4>{statistics.total_contacts}</h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-lg-3 col-md-6 col-12">
      <div className="card h-100">
        <div className="card-body d-flex align-items-center">
          <div className="avatar-sm">
            <span className="avatar-title bg-light text-primary rounded-circle fs-3">
              <i className="ri-time-fill" />
            </span>
          </div>
          <div className="ms-3 flex-grow-1">
            <p className="text-uppercase text-muted mb-1">Avg Resolution</p>
            <h4>
              {parseInt(statistics.average_closed_time_minutes) > 60
                ? `${Math.round(statistics.average_closed_time_minutes / 60)} hrs`
                : `${statistics.average_closed_time_minutes} mins`}
            </h4>
          </div>
        </div>
      </div>
    </div> 
                </div>
              )}
            </>*/}

              <div>
                {/* <DashboardBargraph
                  monthsData={monthsData}
                  weekData={weekData}
                  view={view}
                  setView={setView}
                  year={year}
                  setYear={setYear}
                  month={month}
                  setMonth={setMonth}
                  weekIndex={weekIndex}
                  setWeekIndex={setWeekIndex}
                /> */}
                <DashboardBargraph
  monthsData={monthsData}
  weekData={weekData}
  view={view}
  setView={setView}
  year={year}
  setYear={setYear}
  month={month}
  setMonth={setMonth}
  weekIndex={weekIndex}
  setWeekIndex={setWeekIndex}
/>
                
              </div>

              <div className="row">
                {/* end col sliding section*/}
                <div className="col-12 order-xxl-0 order-first">
                  <CustomerTicketsList
                    data={response}
                    Reload={Reload}
                    options={options}
                    handleSearch={handleSearch}
                    fetchStats={fetchStats}
                  />

                  <div className="d-flex mt-4">
                    {/*Graphical data */}

                    <div className="col-lg-5 ps-3">
                      <div className="card"></div>
                    </div>

                    <div className="col-lg-5 ps-2"></div>
                  </div>
                </div>
                {/* end col */}
              </div>

              <div className="row">
                <div className="col-xl-8">{/* end card */}</div>
                {/* end col */}
                <div className="col-xl-4">
                  {/* card */}
                  <div className="card card-height-100">
                    {/* end card body */}
                  </div>
                  {/* end card */}
                </div>
                {/* end col */}
              </div>
            </div>{" "}
            {/* end .h-100*/}
          </div>{" "}
          {/* end col */}
          {/* end col */}
        </div>
      </div>
    </>
  );
}

const SetfetchStats = (props) => ({
  value: props,
});
export default connect(SetfetchStats)(CustomerSupportPage);

const StyledSuperAdminDashboard = styled.div`
  h1 {
    color: red;
  }
`;
